import apiClient from '../api';

export const getProductList = () => apiClient.get(`/stripe/get/products`);

export const createStripeCustomer = (data, header) => apiClient.post(`/stripe/create/customer`, data, header);

export const createSubscription = (data, header) => apiClient.post(`/stripe/create/subscription`, data, header);

export const getSubscription = (orgId, header) => apiClient.get(`/stripe/subscriptions/status?organizationId=${orgId}`, header);

export const cancelSubscription = (data, header) => apiClient.post(`/stripe/subscriptions/cancel`, data, header);
export const resumeSubscription = (data, header) => apiClient.post(`/stripe/subscriptions/resume`, data, header);
export const changePlan = (data, header) => apiClient.post(`/stripe/subscriptions/change-plan`, data, header);
export const attachPaymentMethod = (data, header) => apiClient.post(`/stripe/attach-payment-method`, data, header);

export const getSubscriberList = (header) => apiClient.get(`/stripe/subscribers/list`, header);